module.exports = __webpack_public_path__ + "static/media/first-img.1029fcf4.jpg";